
import {
  apiShopLists,
  apiShopSwitchStatus,
  apiShopDelete,apiChangeTheme,unLoginUrl,
  apiChangeRemark,apiChangeGrade,apiShopBusinessList,apiShopUpdateBusinessId
} from "@/api/shop";
import { copyClipboard } from '@/utils/util'

import { Component, Prop, Vue } from "vue-property-decorator";
import lsPagination from "@/components/ls-pagination.vue";
import ExportData from "@/components/export-data/index.vue";
import LsDialog from "@/components/ls-dialog.vue";
import { RequestPaging } from "@/utils/util";
import DatePicker from "@/components/date-picker.vue";
import { apiOtherLists } from "@/api/order";
import { apiSelectUser } from '@/api/home'

@Component({
  components: {
    lsPagination,
    ExportData,
    LsDialog,
    DatePicker,
  },
})
export default class ShopList extends Vue {
  /** S Data **/

  apiShopLists = apiShopLists;

  pager: RequestPaging = new RequestPaging();
  targetSid:any='';//目标租户id
  sourceSid:any='';//源租户id
  visible = false;
  businessList: any = [];
  searchObj = {
    set_meal_id: "",
    set_meal_status: "",
    status: "",
    shop_info: "",
    start_time: "",
    end_time: "",
    source: "",
    business_id: "",
    time_type: "",
  };
  otherLists: any = {
    set_meal: [],
    pay_status: [],
    pay_way: [],
    grade: [],
    bussiness_list: [],
    source_list: [],
  };
  userLists: any = [];
  /** E Data **/

  /** S Methods **/
  // 获取订单其他 方式数据
  getOtherMethodList() {
    apiOtherLists().then((res: any) => {
      this.otherLists = res;
    });
  }
  serach(){
      this.pager.page = 1
      this.getShopLists()
  }
  // 获取商城列表
  getShopLists(): void {
   
    this.pager.request({
      callback: apiShopLists,
      params: {
        ...this.searchObj,
      },
    });
  }

  // 修改商城状态
  async shopSwitchStatusEdit(status: number, id: number): Promise<void> {
    await apiShopSwitchStatus({ id });
    this.getShopLists();
  }

  async changeRemarks(text: string, id: number): Promise<void> {
    await apiChangeRemark({ id: id, remark: text });
    this.getShopLists();
  }
 async changeGrade(text: number, id: number): Promise<void> {
   await apiChangeGrade({ id: id, grade: text });
    this.getShopLists();
 }
//  复制商城信息
 copyContent(row:any) {
  // account
   copyClipboard(`${row.company_name}\n管理后台:\n${row.shop_admin_url}\n账号：${row.account}\n密码：${row.account_pwd}\n\n手机客户端:\n${row.shop_mobile_url}\n电脑客户端:\n${row.shop_desktop_url}\n\n后续需要小程序再对接`).then(()=>{
        this.$message.success('复制成功')
            })
            .catch(err => {
                this.$message.error('复制失败')
                console.log(err)
            })
 }
//  无感登录
 uinresponsiveLogin(row:any){
   unLoginUrl({id:row.id}).then((res:any)=>{
     window.open(res.url)
   })
 }
  // 删除商城
  async onShopDelete(row: any): Promise<void> {
    await apiShopDelete({ id: row.id });
    this.getShopLists();
  }
  // 业务员
  getBusinessList() {
    apiShopBusinessList({}).then((res: any) => {
      this.businessList = res;
    });
  }
  changeBusiness(row: any) {
    apiShopUpdateBusinessId({ id: row.id, business_id: row.business_id }).then(() => {
    let refDom:any=this.$refs[`changeBusinessDialog_${row.id}`]
      refDom?.close();
      this.getShopLists();
    }).catch((err) => {
    });
  }
  // 重置搜索
  reset(): void {
    Object.keys(this.searchObj).map((key) => {
      this.$set(this.searchObj, key, "");
    });
    this.getShopLists();
  }

  // 去编辑商城
  toShopEdit(id: number | any): void {
    this.$router.push({
      path: "/shop/lists_detail",
      query: {
        id: id,
      },
    });
  }
  // 复制主题弹窗
  openChangeTheme(id: number | any): void {
   this.visible=true 
   this.targetSid=id
   this.sourceSid=''
  this.getUserLists()
  }
  confirm(){
    this.$confirm('此操作将复制该商城主题覆盖原有商城主题, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          apiChangeTheme({source_sid:this.sourceSid,target_sid:this.targetSid}).then((res:any)=>{
            this.visible=false
            this.getShopLists()
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消复制'
          });
    })
  }
  close(){
    this.visible=false
  }
    // 搜索租户
  filterUser(userName: string = '') {
    this.getUserLists(userName);
  }

  // 获取租户列表
  getUserLists(keyword: string = '') {
    apiSelectUser({ keyword }).then((res: any) => {
      this.userLists = res.lists;
    });
  }
  // 修改超级管理员
  toSuperAdminUpdate(id: number | any): void {
    this.$router.push({
      path: "/shop/modify_account",
      query: {
        id: id,
      },
    });
  }

  // 去商家后台
  toShop(url: any, status: number) {
    if (status == 0) return this.$message.error("该商城暂未营业中");

    if (url.indexOf("https://") === 0) window.open(url);
    else if (url.indexOf("http://") === 0) window.open(url);
    else window.open("http://" + url);
  }

  /** E Methods **/

  /** S ods **/
  created() {
    this.getShopLists();
    this.getOtherMethodList();
  }
}
